import { Stack } from 'react-bootstrap';

export interface AuditedChange {
  name: string;
  new?: unknown;
  old?: unknown;
}

function formatValue(value: unknown): string {
  if (Array.isArray(value)) {
    return value.join(', ');
  }

  if (typeof value === 'object' && value !== null) {
    return JSON.stringify(value);
  }

  return String(value ?? '');
}

export const AuditedChangesCell = ({ changes }: { changes: string | null }) => {
  let formattedChanges: AuditedChange[];

  try {
    const parsed = JSON.parse(changes ?? '[]');

    if (Array.isArray(parsed)) {
      formattedChanges = parsed;
    } else if (typeof parsed === 'object' && parsed !== null) {
      formattedChanges = Object.entries(parsed).map(([name, val]) => {
        if (Array.isArray(val)) {
          return {
            name,
            old: val[0],
            new: val[1]
          };
        }

        return {
          name,
          new: val
        };
      });
    } else {
      formattedChanges = [{ name: 'unknown', new: String(parsed) }];
    }
  } catch (error) {
    formattedChanges = [{ name: 'unknown', new: changes ?? '' }];
  }

  return (
    <Stack>
      {formattedChanges.map((change, index) => (
        <div key={index}>
          {change.old != null && (
            <div>
              <span className="fw-bolder">{`Old ${change.name}: `}</span>
              <span>{formatValue(change.old)}</span>
            </div>
          )}
          {change.new != null && (
            <div>
              <span className="fw-bolder">{`New ${change.name}: `}</span>
              <span>{formatValue(change.new)}</span>
            </div>
          )}
          {change.old == null && change.new == null && (
            <div>
              <span className="fw-bolder">{`${change.name}`}</span>
            </div>
          )}
        </div>
      ))}
    </Stack>
  );
};
